// Solarflare's counters (see backend/games/solarflare.js), as the profile and the leaderboard show them

// A counter's number as it reads: unit 'm' as m or km, 's' (time played) as minutes or hours, anything else as a
// whole number
export function formatStat(value, unit) {
    if (unit === 'm') {
        return value >= 1000 ? `${(value / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })} km` : `${Math.floor(value)} m`;
    }
    if (unit === 's') {
        return value >= 3600 ? `${(value / 3600).toLocaleString(undefined, { maximumFractionDigits: 1 })} h` : `${Math.floor(value / 60)} min`;
    }
    return Math.floor(value).toLocaleString();
}
